/**
 * @generated SignedSource<<957c10843aadd30ea973050582e875f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuggestedQuestionsList_Questions$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionAnswerListItem_Question">;
  readonly " $fragmentType": "SuggestedQuestionsList_Questions";
}>;
export type SuggestedQuestionsList_Questions$key = ReadonlyArray<{
  readonly " $data"?: SuggestedQuestionsList_Questions$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestedQuestionsList_Questions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SuggestedQuestionsList_Questions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionAnswerListItem_Question"
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "e52bfaf1bfdf512391443691c7630554";

export default node;
